import Translate from "../Translate";

export default {
  isVisible: false,
  spinner: false,
  type: "dark",
  message: "",
  scope: null,
  progress: function(text) {
    if (typeof text === "undefined") {
      text = Translate.trans("Pracuji...");
    }
    console.log('progress', text);
    this.isVisible = true;
    this.message = text;
    this.spinner = true;
    this.apply();
  },
  notify: function(text, type) {
    this.isVisible = true;
    this.spinner = false;
    this.type = type ? type : "dark";
    this.message = text;
    var that = this;
    setTimeout(function() {
      that.clear();
    }, 5000);
    this.apply();
  },
  clear: function() {
    this.message = "";
    this.isVisible = false;
    this.spinner = false;
    this.type = "dark";
    this.apply();
  },
  apply: function() {
      this.scope.$evalAsync();
      return;
    if (!this.scope.$$phase) {
        this.scope.$digest();
      this.scope.$apply();
    } else {
        var that = this;
        setTimeout(function(){console.log('calling apply');that.apply();}, 550);
    }
  }
};



// WEBPACK FOOTER //
// ./src/util/Toastr.js